import { getCookie } from "../../utils/cookieUtil";
export default {
  state: {
    userInfo: {},
    token: ''
  },
  mutations: {
    updateUserInfo(state, userData) {
      state.userInfo = userData
    },
    updateToken(state, userToken) {
      state.token = userToken
    },
  },
  actions: {
    getUserInfo(context) {
      let userData =  JSON.parse(getCookie('userInfo'))
      context.commit('updateUserInfo',userData)
    },
    getToken(context) {
      let userToken =  JSON.parse(getCookie('token'))
      context.commit('updateToken',userToken)
    },
  }
};


// WEBPACK FOOTER //
// ./src/store/modules/user.js